//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['data', 'itemWidth', 'activeCss'],
  // data 多级选择的数据
  // data: [[], {}, {}....]
  // data: [[], [], []....]
  // itemWidth 每级的宽度
  // activeCss 选中时的样式
  data () {
    return {
      selected: [],
      selectItem: [
        {
          prev: '',
          cur: ''
        }
      ]
    }
  },
  computed: {
    // contBoxW: function () {
    //   let len = this.data.length
    //   return {
    //     flexBasis: this.itemWidth
    //   }
    // }
  },
  components: {},
  methods: {
    setSelectItem: function () {
      let len = this.data.length,
        tempArr = []
      this.data.forEach(function (item, index, arr) {
        let obj = Object.create(null)
        obj['prev'] = ''
        obj['cur'] = ''
        tempArr.push(obj)
      })
      this.selectItem = tempArr
    },
    switchItem: function (index, subIndex) {
      // selectItemModify
      this.selectItemModify()
      // 保存数据
      // this.selected = { index: index, num: subIndex }
      this.storeSelected(index, subIndex)
      // this.isActive = true
      // let curData = this.data[index] // 当前列的数据
      this.selectItem[index].prev = this.selectItem[index].cur
      this.selectItem[index].cur = subIndex
      if (this.selectItem[index].prev !== '') {
        this.data[index][this.selectItem[index].prev].isActive = false
      }
      this.data[index][this.selectItem[index].cur].isActive = true
      // 关闭
      if (this.data[index][this.selectItem[index].cur].trail) {
        this.$emit('close')
      } else {
        // 发送请求事件
        let num = this.data[index][this.selectItem[index].cur].deptId
        this.$emit('getSub', this.selected)
      }
    },
    // 保存数据
    storeSelected: function (index, subIndex) {
      if (this.selected.length - 1 >= index) {
        this.selected.splice(index, this.selected.length - index)
      }
      this.selected.push({layer: index, index: subIndex, deptId: this.data[index][subIndex].deptId})
    },
    selectItemModify: function () {
      let obj = Object.create(null)
      obj.prev = ''
      obj.cur = ''
      this.selectItem.push(obj)
    }
  },
  mounted () {
    // this.setSelectItem()
    // console.log(this.data)
  }
}



// WEBPACK FOOTER //
// ./src/components/clinic/mulClassSelect.vue